import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { isEqual, isUndefined, get } from 'lodash'
import api from 'common/api'
import qs from '@scoir/query-string'

import { ErrorBoundary } from '@scoir/error-reporter'

import Details from './Details'
import Overview from './Overview'
import SourceOfData from './SourceOfData'

import './index.scss'

export class HighSchoolOverview extends React.Component {
  state = {
    details: undefined,
  }
  componentDidMount() {
    if (!isUndefined(this.props.detailSchoolId)) {
      this.loadSchool(this.props.detailSchoolId)
    }
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.detailSchoolId !== this.props.detailSchoolId ||
      !isEqual(prevProps.locationFilters, this.props.locationFilters)
    ) {
      if (!isUndefined(this.props.detailSchoolId)) {
        this.loadSchool(this.props.detailSchoolId)
      } else {
        this.setState({ details: undefined })
      }
    }
  }
  loadSchool(hsId) {
    api
      .get(`/api/highschools/${hsId}/locations?${qs.stringify(this.props.locationFilters)}`)
      .then((details) => this.setState({ details: details[0] }))
  }
  render() {
    const highSchool = get(this.state.details, 'HighSchool')
    return (
      <ErrorBoundary>
        <div className="selection-overview-details">
          {!isUndefined(highSchool) && (
            <>
              <Details
                onOverviewClose={this.props.onOverviewClose}
                highSchool={highSchool}
              />
              <Overview highSchool={highSchool} />
              <SourceOfData />
            </>
          )}
        </div>
      </ErrorBoundary>
    )
  }
}

HighSchoolOverview.propTypes = {
  onOverviewClose: PropTypes.func,
  detailSchoolId: PropTypes.string,
  locationFilters: PropTypes.object,
}

export default connect((store) => ({
  locationFilters: {
    virtual: get(store.mapFilters.record, 'virtual'),
    startDate: get(store.mapFilters.record, 'visitRange.from'),
    endDate: get(store.mapFilters.record, 'visitRange.to'),
  },
}))(HighSchoolOverview)
